<template>
  <div class="formdata building">
    <div class="header-container">
    <h3 id="on_site_appointment_question">Möchten Sie einen Vor-Ort-Termin?</h3>
    <span class="center">In Ihrem Gebiet können wir Ihnen einen Termin vor Ort anbieten. Dort überprüfen wir dann die Gegebenheiten des Hauses und erstellen ein Angebot.</span>
</div>
    <CustomRadioGroup
        :options="appointmentOptions"
        v-model="selectedAppointmentOption"
        aria-labelledby="on_site_appointment_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'appointment_option_' + option.value">
          <img v-if="option.image" :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button class="button button_yellow right" v-if="selectedAppointmentOption" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '../../stores/workflow.js';
import { appointmentOptions} from '@/data/appointmentOptions';
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";

const workflowStore = useWorkflowStore();


const getAppointmentOptionEventData = (selectedValue) => {
  const fullAppointmentOption = appointmentOptions.find(bt => bt.value === selectedValue);

  if (fullAppointmentOption) {
    return {
      value: selectedValue,
      available: fullAppointmentOption.available
    };
  }
  return null;
};


const selectedAppointmentOption = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.appointment || null;
  },
  set(newValue) {
    const eventData = getAppointmentOptionEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_APPOINTMENT_TYPE',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedAppointmentOption.value) {
    const eventData = getAppointmentOptionEventData(selectedAppointmentOption.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>
#app-ves-clickstream .center{
  display: block;
  text-align: center;
  margin-bottom: 45px;
}

#app-ves-clickstream .formdata h3 {
  /* Setzt den unteren Margin auf einen kleineren Wert (oder 0),
     damit das Span näher an die Überschrift rückt. */
  margin-bottom: 3px;
}
</style>